const validEmail = (email) => (email.match(/^[^@\s]+@[^@\s]+$/));
export { validEmail };
